// extracted by mini-css-extract-plugin
export default {"button":"CartItems_button__ONOEt","img":"CartItems_img__1crnH","title":"CartItems_title__IM6up","price":"CartItems_price__9xpg9","quantity":"CartItems_quantity__y0cnj"};